export const OPP_PRIMARY_NAVIGATION = [
  { id: 'home', key: 'nav.home', href: '/' },
  { id: 'letters', key: 'nav.letters', href: '/letters' },
  { id: 'write', key: 'nav.write', href: '/write' },
  { id: 'drift', key: 'nav.drift', href: '/drift' },
  { id: 'me', key: 'nav.me', href: '/me' },
] as const;

export const OPP_TOP_NAVIGATION = [
  { id: 'home', key: 'nav.home', href: '/' },
  { id: 'letters', key: 'nav.letters', href: '/letters' },
  { id: 'discover', key: 'nav.discover', href: '/discover' },
  { id: 'drift', key: 'nav.drift', href: '/drift' },
] as const;

export type OppPrimaryNavigationId = (typeof OPP_PRIMARY_NAVIGATION)[number]['id'];
